/**
 * Created by rathompson on 1/5/22
 * File: TermsAndConditions
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { useEffect, useMemo, useState } from 'react'
import { Checkbox, SubmitButton } from '@panwds/react-form-legacy'
import {
  AGREE_TERMS_PREFIX,
  BUTTON_ACTIVATE_NOW,
  LINK_TERMS,
} from '../../../constants/LabelConstants'
import { Body, Button, noop, Tooltip } from '@panwds/react-ui'
import Link from '../../../../common/components/link/Link'
import { BUTTON_CANCEL } from '../../../../common/constants/LabelConstants'
import { useFormContext } from 'react-hook-form'
import { ACTIVATE_TOOLTIP_NO_MSG, TOOLTIP_ACTIVATE_BUTTON } from '../../constants/SubscriptionConstant'
import { DATA_ALLOCATION_SUBMIT, DATA_TEST_EULA } from '../../constants/TestingDataIds'
import { ALLOWED_LICENSE_CONTEXTS, LICENSE_CONTEXT_TO_APP_ID } from '../../../../common/constants/GlobalConstants'

const Terms = ({
  onCancel,
  loading,
  licenseContext,
  selectedTSGInstances,
  validationReTrigger = false,
  mspFlow = false,
  validationFailure = false,
  rest }) => {
  const { formState, trigger } = useFormContext()
  const { isValid, errors = {} } = formState
  const { is_eula_accepted } = errors
  const [checked, setChecked] = useState(false)
  useEffect(() => {
    trigger('is_eula_accepted')
    if (checked) {
      trigger()
    }
  }, [checked, trigger])

  useEffect(() => {
    validationReTrigger && trigger()
  }, [validationReTrigger, trigger])

  const alreadyHasService = useMemo(() => {
    trigger('is_eula_accepted')
    if (ALLOWED_LICENSE_CONTEXTS.includes(licenseContext)) {
      return Boolean(selectedTSGInstances.has(LICENSE_CONTEXT_TO_APP_ID[licenseContext]))
    }
    return false
  }, [licenseContext, selectedTSGInstances, trigger])

  const valid = useMemo(() => {
    return isValid && !alreadyHasService && !Object.keys(errors)?.length
  }, [alreadyHasService, errors, isValid])

  const isActivateBtnDisabled = useMemo(() => {
    if ((mspFlow && !validationFailure) || !mspFlow) {
      return loading || !valid
    }
    else {
      return true
    }
  }, [loading, mspFlow, valid, validationFailure])

  const toolTipMessage = useMemo(() => {
    if (is_eula_accepted) {
      return 'You must agree to the terms and conditions'
    }
    return !loading ? 'You have one or more issues with your form' : 'Activation in Process'
  }, [is_eula_accepted, loading])

  return (
    <div className="tw-flex tw-justify-between tw-bg-gray-100 dark:tw-bg-gray-1050 tw-p-3">
      <div className="tw-flex tw-gap-2 tw-items-center" >
        <Checkbox
          data-testid={DATA_TEST_EULA}
          disabled={loading}
          name={'is_eula_accepted'}
          checked={checked}
          label={
            <Body size="lg">{AGREE_TERMS_PREFIX}<Link target="_blank" href="https://www.paloaltonetworks.com/legal/eula">{LINK_TERMS}</Link></Body>
          }
          register={{
            required: true,
            onChange: async (event) => setChecked(event.currentTarget.checked),
          }} />
      </div>
      <div className="tw-flex tw-gap-2">
        <Button
          appearance="secondary-destructive"
          onClick={onCancel}
          disabled={loading}
        >{BUTTON_CANCEL}</Button>
        <Tooltip label={isActivateBtnDisabled ? toolTipMessage : !mspFlow && rest?.userFlow.length ?
          TOOLTIP_ACTIVATE_BUTTON : ACTIVATE_TOOLTIP_NO_MSG}>
          <div>
            <SubmitButton
              data-testid={DATA_ALLOCATION_SUBMIT}
              disabled={isActivateBtnDisabled}
            >{BUTTON_ACTIVATE_NOW}</SubmitButton>
          </div>
        </Tooltip>
      </div>
    </div>
  )
}

Terms.propTypes = {}

Terms.defaultProps = {
  onCancel: noop,
  loading: false,
  licenseContext: '',
  selectedTSGInstances: []
}

export default Terms
